export default {
  create_qrph: '创建 QR Stand',
  qr_stand_type: '立牌类型',
  qr_stand_name: 'QR Stand 名称',
  new_link: '新链接',
  edit_link: '编辑链接',
  single_payment_link: '单个 Payment Links',
  batch_payment_link: '批量 Payment Links',
  batch_link_details: '批量链接详情',
  cancel_upload: '取消上传',
  proceed_upload: '继续上传',
  duplicate_upload_detected: '检测到重复上传',
  tip_1: '选择支付方式和渠道，然后填写Payment Links详细信息',
  tip_2: '下载并填写模板以创建批量链接',
  tip_3: '使用最新的模板文件上传您填写的excel工作表以提交批量链接',
  tip_4: '通过上传excel文件，批量创建Payment Links，从多个银行账户/电子钱包收款。',
  tip_5: '创建一个Payment Links，仅从一个特定的银行账户/电子钱包收款。',
  tip_6: '您正在尝试上传一个已经存在的文件。请检查您上传的文件，确保这是您想要进行的操作。',
  active_status: '生效状态',
  active: '生效',
  inactive: '失效',
  payment_status: '支付状态',
  paid: '已支付',
  unpaid: '未支付',
  link_id: '链接ID',
  link_no: '链接编号',
  title: '标题',
  amount: '金额',
  type: '类型',
  create_time: '创建时间',
  complete_time: '完成时间',
  remark: '备注',
  copy_link: '复制链接',
  link_qr: '链接',
  show_qr_code: '显示二维码',
  link_info: '链接信息',
  link_title: '链接标题',
  order_mode: '订单模式',
  fixed_amount: '固定金额',
  based_on_product: '基于产品',
  customer_to_enter: '顾客输入金额',
  product: '产品',
  add_another_product: '增加另一个产品',
  add_new_product: '新增产品',
  edit_product: '编辑产品',
  product_info: '产品信息',
  product_name: '产品名称',
  price: '价格',
  quantity: '数量',
  allow_adjust: '用户可调整数量',
  image: '图片',
  payment_description: '支付描述',
  customer_info: '顾客信息',
  collect_customer_info: '收集顾客信息',
  customer_name: '顾客姓名',
  customer_email: '顾客邮箱',
  customer_mobile: '顾客手机',
  other_info: '其他信息',
  add_customer_field: '添加自定义信息',
  text: '文本',
  number_only: '纯数字',
  marked_as_required: '必填',
  mark_as_optional: '非必填',
  add_another_field: '添加多一个字段',
  link_configuration: '链接设置',
  link_type: '链接类型',
  one_time: '一次性',
  reusable: '多次使用',
  max_of_payments_accepted: '支付成功次数限制',
  expiry_time: '过期时间',
  create_payment_link: '创建Payment Link',
  edit_payment_link: '编辑Payment Link',
  payment_link_details: 'Payment Link详情',
  download_qr_code: '下载二维码',
  checkout_order_id: '收银台单号',
  transaction_id: '交易编号',
  payment_channel: '支付渠道',
  link_details: '链接详情',
  transactions: '链接交易',
  other: '其他',
  custome_field: '自定义信息',
  time_zone_tips: '当前时区为',
  merchant_order_id: '商户订单号',
  link_expired_tips: '链接已过期',
  reach_payment_limit_tips: '达到支付限制',
  both_tips: '链接已过期,且达到支付限制',
  overview: '概要',
  checkout_details: '收银台详情',
  transaction_details: '交易详情',
  time_line: '时间线',
  payment_breakdown: '支付明细',
  order_amount: '订单金额',
  transaction_fee: '交易手续费',
  payment_amount: '支付金额',
  customer_payin_journey: '交易记录',
  delete_product_tips: '此产品将从产品库中删除，请确认',
  add_product_or_search_on_list: '添加或者搜索产品',
  no_more_data: '没有更多数据',
  unlimited: '无限',
  transaction_fee_charge_mode: '手续费承担模式',
  transaction_fee_charge_mode1: '商户承担',
  transaction_fee_charge_mode2: '用户承担',
  link_icon: '支付链接图标',
  upload_photo: '上传图片',
  available_edits_left: '剩余可编辑次数',
  create_successful_tips: 'Payment Link创建成功,分享链接给你的顾客',
  update_successful_tips: '你的Payment Link 已编辑成功！',
  field_empty_tips: '请填写其他信息中的自定义信息名称',
  duplicate_label_name: '字段名称重复',
  label_name: '字段名称',
  only_successful_transactions: '只包含成功交易',
  branch_code: '网点编码',
  branch_name: '网点名称',
  payment_success_page: '支付成功页',
  custom_message: '自定义消息',
  max_file_tips: '图片尺寸不超过2MB,请重新上传',
  min_img_resolution: ''
}
